import storage from '../../../util/storage';

const LAYOUT_SETTINGS = 'WSL_LAYOUT_SETTINGS';

/**
 * @description Cache util to fetch layout context values to persist layout for user on refresh
 */
export const getCachedLayoutSettings = () => {
  const cachedLayoutSettings = storage.getItem(LAYOUT_SETTINGS);
  if (!cachedLayoutSettings) return null;

  try {
    const parsed = JSON.parse(cachedLayoutSettings);

    const layoutSettingsMap = new Map<string, string>();
    parsed.forEach(([key, value]: [key: string, value: string]) =>
      layoutSettingsMap.set(key, value)
    );

    return layoutSettingsMap;
  } catch (err) {
    return null;
  }
};

/**
 * @description Util that receives a state object of context values and updates the current cache
 * with the new values.
 */
export const updateCachedLayoutSettings = (state: Record<string, any>) => {
  const layoutSettingsMap =
    getCachedLayoutSettings() || new Map<string, string>();

  Object.entries(state).forEach(([key, value]) =>
    layoutSettingsMap.set(key, value)
  );

  const layoutSettingsArr = Array.from(layoutSettingsMap).map(
    setting => setting
  );

  storage.removeItem(LAYOUT_SETTINGS);
  storage.setItem(LAYOUT_SETTINGS, JSON.stringify(layoutSettingsArr));
};

export default {
  getCachedLayoutSettings,
  updateCachedLayoutSettings,
};
